
<template lang='pug'>
div
  v-card-text.breadcrumb.text-xs-center.px-0.mx-0
    v-layout(row, wrap)
      v-flex(xs1)
        .toolTip--text.btn_back.text-xs-right(style='cursor: pointer;', flat='', @click.prevent='lastPage(back)')
          v-icon.pb-0.pr-2(size='15px', color='toolTip') fas fa-angle-double-left
          span
            | Regresar
      v-flex(xs12='', md10='')
        div
          slot
</template>

<script>
import { eventBus } from "../main";
export default {
  props: ["back", "chapter"],
  name: "breadcrumb",
  data() {
    return {};
  },
  methods: {
    lastPage(page) {
      eventBus.$emit("last_page", page);
    }
  }
};
</script>
